import Head from 'next/head';
import CommentModel from '../components/CommentModel';
import Feed from '../components/Feed';
import Sidebar from '../components/Sidebar';
import Rightside from '../components/Rightside';export default function Home({ newsResults, randomUsersResults }) {
  return (
    <div>
      <Head>
        <title>Isocial</title>
        <meta name="description" content="Generated by create next app" />
        <link
          rel="icon"
          href="https://isocial.vercel.app/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fisocial.89f0087a.png&w=256&q=75"
        />
      </Head>

      <main className="flex min-h-screen mx-auto bg-gray-900">
        {/* Sidebar */}
        <Sidebar />

        {/* Feed */}

        <Feed />

        {/* Widgets */}

        <Rightside
          newsResults={newsResults?.articles}
          randomUsersResults={randomUsersResults?.results || null}
        />

        {/* Modal */}
        <CommentModel />
      </main>
    </div>
  );
}


export async function getServerSideProps() {
  const newsResults = await fetch(
    "https://saurav.tech/NewsAPI/top-headlines/category/business/us.json"
  ).then((res) => res.json());

  // Who to follow section

  let randomUsersResults = [];

  try {
    const res = await fetch(
      "https://randomuser.me/api/?results=30&inc=name,login,picture"
    );

    randomUsersResults = await res.json();
  } catch (e) {
    randomUsersResults = [];
  }

  // const randomUsersResults = await fetch(
  //   "https://randomuser.me/api/?results=30&inc=name,login,picture"
  // ).then((res) => res.json());

  return {
    props: {
      newsResults,
      randomUsersResults,
    },
  };
}
